import React from 'react'
import Lottie from 'react-lottie'
import animationData from './data'

const LoadingTruck = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        maxWidth: '1440px',
        justifySelf: 'center',
        alignItems: 'center',
      }}
    >
      <Lottie options={defaultOptions} />
    </div>
  )
}

export default LoadingTruck
